// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { viewStyles } from "@steiner/Overrides/Widgets/ProductDetails/ProductDetailsView";
import { color, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

viewStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 430px 1fr; /* Two columns by default, first column width 430px */
        grid-template-rows: auto; /* Rows will size based on content */
        gap: 22px;
        ${xScreen("lte", "md")} {
            gap: 20px;
            grid-template-columns: 358px 1fr;
        }
        ${xScreen("lte", 765)} {
            display: flex;
            flex-direction: column;
        }
        .full-width {
            grid-column: 1 / -1; /* Span full width */
        }
    `,
};

viewStyles.specificationsContainer = {
    css: css`
        grid-column: 1 / -1;
    `,
};

viewStyles.productNumbersWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-bottom: 8px;
        gap: 8px;
        width: ${({ shouldTakeFullWidth }: any) => (shouldTakeFullWidth ? "85%" : "50%")};
        ${xScreen("lte", "lg")} {
            width: ${({ shouldTakeFullWidth }: any) => (shouldTakeFullWidth ? "100%" : "70%")};
        }
        ${xScreen("lte", 1200)} {
            width: 100%;
        }
        ${xScreen("lte", "md")} {
            flex-direction: column;
            gap: 8px;
        }

        @media print {
            flex-direction: row;
            justify-content: flex-start;
            gap: 0;
        }
    `,
};

viewStyles.leftColumnGridItem = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
        ${xScreen("lt", "sm")} {
            gap: 8px;
        }
    `,
};

viewStyles.divider = {
    css: css`
        width: 85%;
        border-bottom: 1px solid ${color("common.border")};
        margin: 20px 0;
        flex-wrap: wrap;
        ${xScreen("lte", "lg")} {
            width: 100%;
        }
        ${xScreen("lte", "md")} {
            margin-top: 0;
        }
    `,
};

viewStyles.inventoryWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        row-gap: 8px;
        margin-bottom: 12px;
        > div {
            width: auto;
        }
        ${xScreen("lte", "md")} {
            row-gap: 12px;
        }
    `,
};

viewStyles.showOnMobile = {
    css: css`
        ${xScreen("gte", 766)} {
            display: none;
        }
    `,
};

viewStyles.hideOnMobile = {
    css: css`
        ${xScreen("lte", 765)} {
            display: none;
        }
    `,
};

viewStyles.showOnTablet = {
    above: "md",
};

viewStyles.hideOnTablet = {
    below: "lg",
};
